import React, { useState, useEffect, useContext } from 'react';
import logo from "../img/logo-02.png";
import { useNavigate } from 'react-router-dom';
import supabase from "../Supa";
import Loading from "./Loading";
import ProgressSteps from "./components/ProfileProgress"
import TicketSteps from "./components/TicketProcess"
import { MyContext } from "../context";



function Profile(){

    const { updateuserId, TicketBoolean, updateTicketBoolean  } = useContext(MyContext);

    //const [userId, setUserTicket] = useState([]);
    const [users, setUsers] = useState([]);
    //const [TicketBoolean, setTicketBoolean] = useState("")
    const [loading, setLoading] = useState(true);

    let navigate = useNavigate()

    useEffect(() => {

        getUser();
        
    }, [])

    async function getUser(){
        try{

            
            const { data: { user } } = await supabase.auth.getUser()
            if(user != null){
            
            setUsers(user)
           // setTicketBoolean(user.user_metadata.Ticket)
           updateTicketBoolean(user.user_metadata.Ticket) 
            updateuserId(user.id)
            setLoading(false)

            console.log(user.user_metadata.Ticket)
           
            }else{
                
                setUsers({user_metadata:{Ticket:"null"}})
                
            }

           /* const { data, error } = await supabase
            .from('user')
            .select()


            if(error) throw error;

            if(data != null){
                setUserTicket(data)
            }*/
        }catch(e){
            console.log(e.message)
        }
    }

    async function out(e){


        e.preventDefault()
    
        try {
        
      
        const { error } = await supabase.auth.signOut()
    
         
         if (error) throw error
         sessionStorage.removeItem('token')
         navigate('/')
             
        }catch(error){
         console.log(error)
        }
           
    }

    return (
       
        <>
         {loading === true ? <Loading /> :
       <div className="wrap profile" style={{display:"block"}}>
       <div style={{position:"absolute", marginTop:"-80px", marginLeft:"40px"}}>  
       <img src={logo} className="Login-animation a6" style={{ margin: "0 auto 10px", width: "70px" }} alt="Login" /></div>

        <div className="contentWrap profilebox" style={{backgroundColor:"none" }}>


        <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        
                     <span class="material-symbols-rounded">how_to_reg</span>

                        </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Welcome</h6> <span>Please Fill in the Below Information</span>
                        </div>
                    </div>
                    <div class="badge" style={{display: "flex"}}> 
                    <div class="material-symbols-rounded plantLink" onClick={out}>logout</div>
                      {/* 
                    <div class="material-symbols-rounded plantLink" >settings</div> */} 
                   </div>
         </div>
                <hr />
<div style={{marginBottom:"60px"}}></div>


{TicketBoolean === "yes" ? <TicketSteps /> : <ProgressSteps /> }

          
        </div>
      </div>}
        </>
    )
}

export default Profile;